'use client';

import { SvgIcon } from '@/components/SvgIcon';
import { cn } from '@/lib/utils';

import { LIVE_CHAT_PLACEHOLDER_ID } from './consts';

import ChatIcon from '~/icons/annotation.svg';
import { IconButton } from '../../atoms/IconButton';

// Used to improve web vitals score.
// Renders a button immediately as part of the DOM and hides
//  it when the live chat has been interacted with.
export function LiveChatPlaceholder() {
  return (
    <IconButton
      id={LIVE_CHAT_PLACEHOLDER_ID}
      type='button'
      aria-label='Open live chat'
      className={cn(
        'stroke-base-black',
        'h-15 w-15 rounded-full shadow-popup bg-brand-500',
        'fixed z-[9999] mb-4 mr-2 bottom-0 right-0'
      )}
    >
      <SvgIcon
        src={ChatIcon}
        className='h-7 w-7 text-base-black'
        aria-hidden='true'
      />
    </IconButton>
  );
}
